import React, { useState, useRef, useEffect } from "react";

import { Typography, Table, Row, Icon, Button, Dropdown, Menu, Modal, Col } from "antd";

import Loader from "components/Loader/Loader";
import { deleteAppVersionApi, fetchAppVersionListApi } from "utils/apiService";

const { Text } = Typography;

const VersionList = ({ ...props }) => {
	const [loading, setLoading] = useState(false);
	const [tableLoading, setTableLoading] = useState(true);

	const [versionList, setVersionList] = useState([]);

	const [deleteModal, setDeleteModal] = useState(false);
	const deleteVersion = useRef([]);

	const loadTable = () => {
		setTableLoading(true);
		fetchAppVersionListApi({
			requestData: {},
			resCallback: () => {
				loading && setLoading(false);
				setTableLoading(false);
			},
			res200Callback: (res) => {
				setVersionList(res.data.version_list);
			},
		});
	};

	useEffect(() => {
		loadTable();
	}, []);

	const columns = [
		{
			title: "Version Number",
			dataIndex: "version",
			key: "versionNumber",
			render: (data) => (
				<Text style={{ fontStyle: "normal", fontWeight: "bold", fontSize: "16px", lineHeight: "24px", color: "#181818", whiteSpace: "nowrap" }}>
					{data || "-"}
				</Text>
			),
		},
		{
			title: "Last edited",
			dataIndex: "date_modified",
			key: "releasedOn",
			render: (data) => <div style={{ whiteSpace: "nowrap" }}>{data}</div>,
		},
		{
			title: "",
			dataIndex: "uuid",
			key: "uuid",
			render: (uuid) => {
				return (
					<div style={{ width: "16px" }}>
						<Dropdown
							placement={"bottomLeft"}
							onClick={(e) => {
								e.stopPropagation();
							}}
							style={{ marginLeft: "0" }}
							overlay={
								<Menu>
									<Menu.Item
										onClick={(e) => {
											e.domEvent.stopPropagation();
											props.history.push(`${props.location.pathname || "whats-new-app"}/${uuid}`);
										}}>
										<Text style={{ color: "#181818" }}>Edit</Text>
									</Menu.Item>
									<Menu.Item
										onClick={(e) => {
											e.domEvent.stopPropagation();
											deleteVersion.current = uuid;
											setDeleteModal(true);
										}}>
										<Text style={{ color: "#e3102f" }}>Delete</Text>
									</Menu.Item>
								</Menu>
							}>
							<Icon
								type="more"
								onClick={(e) => {
									e.stopPropagation();
								}}
								style={{ fontSize: "16px", color: "#747474", marginLeft: "52px" }}
							/>
						</Dropdown>
					</div>
				);
			},
		},
	];

	return loading ? (
		<Row type="flex" align="middle" justify="center" style={{ marginTop: "200px" }}>
			<Loader />
		</Row>
	) : (
		<>
			<Row type="flex" align="middle" justify="space-between">
				<Text
					style={{
						color: "#181818",
						/*fontFamily: "Gotham",*/ fontStyle: "normal",
						fontWeight: "bold",
						fontSize: "24px",
						lineHeight: "39px",
						marginBottom: 16,
					}}>
					Version Releases
				</Text>
				<Button
					onClick={() => {
						props.history.push(`${props.location.pathname || "whats-new-app"}/create`);
					}}
					style={{
						display: "flex",
						alignItems: "center",
						padding: "8px 16px",
						color: "#FFFFFF",
						fontSize: "16px",
						lineHeight: "24px",
						background: "#fec708",
						borderRadius: "5px",
						height: "100%",
						margin: "0 0 0 12px",
					}}>
					<Icon
						type="plus"
						style={{
							height: "16px",
						}}
					/>
					Create Note
				</Button>
			</Row>
			<Table
				columns={columns}
				dataSource={versionList}
				pagination={{ showQuickJumper: true, pageSize: 50 }}
				style={{ overflow: "none" }}
				// onChange={(pagination) => {
				// 	props.updatePage(pagination.current);
				// }}
				onRow={(obj) => ({
					onClick: () => {
						props.history.push(`${props.location.pathname || "whats-new-app"}/${obj.uuid}`);
					},
				})}
				loading={props.tableLoading}
			/>
			<Modal centered visible={deleteModal} destroyOnClose maskClosable={false} onCancel={() => setDeleteModal(false)} footer={null}>
				<Row className="modal-row">
					<Row>
						<Icon
							type="delete"
							style={{
								color: "#181818",
								fontSize: "24px",
								marginRight: "16px",
							}}
						/>
						<Text
							style={{
								fontWeight: "bold",
								color: "#181818",
								fontSize: "24px",
							}}>
							Delete item
						</Text>
					</Row>
					<Row style={{ marginTop: "24px" }}>
						<Col span={24}>
							<Text>Are you sure you want to delete this Version Details?</Text>
						</Col>
						<Col
							style={{
								marginTop: "60px",
								textAlign: "right",
							}}
							span={18}>
							<Button
								size="large"
								style={{
									height: "40px",
									boxShadow: "none",
									borderRadius: "20px",
									border: "none",
									backgroundColor: "#FFFFFF",
									color: "#181818",
								}}
								onClick={() => setDeleteModal(false)}>
								Cancel
							</Button>
						</Col>
						<Col
							style={{
								marginTop: "60px",
								textAlign: "right",
							}}
							span={6}>
							<Button
								size="large"
								style={{
									height: "40px",
									borderRadius: "2px",
									border: "none",
									backgroundColor: "#C91713",
									color: "#FFFFFF",
								}}
								onClick={() => {
									deleteAppVersionApi({
										requestData: {
											uuid: deleteVersion.current,
										},
										res200Callback: () => {
											setDeleteModal(false);
											loadTable();
										},
									});
								}}>
								Delete
							</Button>
						</Col>
					</Row>
				</Row>
			</Modal>
		</>
	);
};

export default VersionList;
